const firebaseConfig = {
    apiKey: "AIzaSyBUotcz685ws29SwpYp_qRraO4lkfI3Up8",
    authDomain: "baza-e5e0d.firebaseapp.com",
    projectId: "baza-e5e0d",
    storageBucket: "baza-e5e0d.appspot.com",
    messagingSenderId: "554240952447",
    appId: "1:554240952447:web:479d458891a200e11e574a"
};

export default firebaseConfig;